'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {
  enableBackground: 'new 0 0 332.1 73.1',
  height: '24px'
};

exports.default = function (_ref) {
  var _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement('svg', {
    alt: 'Finbursa logo',
    style: customStyles,
    viewBox: '0 0 332.1 73.1',
    xmlns: 'http://www.w3.org/2000/svg',
    className: className ? className + ' icon icon-gen-logo-black' : 'icon icon-gen-logo-black'
  }, _react2.default.createElement('g', null, _react2.default.createElement('g', {
    className: 'logo-description'
  }, _react2.default.createElement('path', {
    fill: '#1D7485',
    d: 'M91.6,72.3V44.6h19.5V51H99.7v5.3H110v6.1H99.7v9.8H91.6z'
  }), _react2.default.createElement('path', {
    fill: '#1D7485',
    d: 'M120.1,72.3V44.6h8.2v27.8H120.1z'
  }), _react2.default.createElement('path', {
    fill: '#1D7485',
    d: 'M138.5,72.3V44.6h6.3l10.7,14.4h0.2V44.6h7.7v27.8h-6.3l-10.8-14.6h-0.2v14.6H138.5z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M173.7,72.3V44.6h13.6c5.7,0,9,2.6,9,6.9c0,3.2-2.4,5.6-5.6,6v0.2c3.8,0.1,6.9,2.9,6.9,6.6 c0,4.9-3.8,8.1-9.8,8.1H173.7z M181.8,55.7h3.2c2.1,0,3.4-1.1,3.4-2.8c0-1.7-1.2-2.8-3.3-2.8h-3.3V55.7z M185.3,66.7 c2.5,0,4-1.1,4-3.2c0-2-1.5-3.1-3.9-3.1h-3.5v6.4H185.3z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M214.4,61.5c0,2.9,1.4,4.5,4.1,4.5c2.6,0,4.1-1.6,4.1-4.5v-17h8.2v17.9c0,6.3-4.9,10.4-12.2,10.4 c-7.3,0-12.2-4-12.2-10.4V44.6h8.2V61.5z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M249,72.3h-8.2V44.6h12.3c7.4,0,11.2,3.5,11.2,9.4c0,3.3-1.6,6.4-4.5,7.8l5.3,10.5h-9.1l-4.4-9.3H249V72.3z M249,57.6h3.4c2.3,0,3.7-1.4,3.7-3.5c0-2.1-1.5-3.5-3.7-3.5H249V57.6z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M280.3,64.1c0.2,1.6,2.2,2.6,4.3,2.6c2.4,0,3.9-1,3.9-2.3c0-1.3-1-1.8-4-2.4l-3.7-0.7 c-5.1-0.9-7.9-3.8-7.9-8.2c0-5.6,4.8-9.2,11.4-9.2c7.4,0,11.5,3.4,11.6,8.8h-7.4c-0.1-1.7-1.8-2.8-4-2.8c-2.1,0-3.5,0.9-3.5,2.3 c0,1.3,1.1,2,3.8,2.5l3.8,0.7c5.4,0.9,7.9,3.5,7.9,8c0,5.7-4.8,9.3-12.1,9.3c-7.4,0-11.9-3.1-11.9-8.7H280.3z'
  }), _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M321.5,66.8h-8.5l-1.4,5.5h-8.3l9.1-27.8h10.2l9.1,27.8H323L321.5,66.8z M314.5,61h5.5L317.4,51h-0.2 L314.5,61z'
  })), _react2.default.createElement('path', {
    fill: '#1D7485',
    d: 'M41.4,41.3c2.5-2.5,4-5.9,4-9.5c0-3.4-1.2-6.5-3.4-9c2.1-2.4,3.4-5.5,3.4-9c0-7.4-6-13.5-13.5-13.5 c0,0,0,0,0,0l-31.5,0l0,45l9,0l0-36l22.5,0l0,0c2.5,0,4.5,2,4.5,4.5c0,2.5-2,4.5-4.5,4.5l0,0l-13.5,0v0l0,0l0,9l13.5,0l0,0l0,0h0v0 c1.2,0,2.3,0.5,3.2,1.3c0.8,0.8,1.3,2,1.3,3.2c0,2.5-2,4.5-4.5,4.5l0,0l-13.5,0l0,9l13.5,0c0,0,0,0,0,0 C35.5,45.3,38.9,43.9,41.4,41.3z'
  }), _react2.default.createElement('path', {
    fill: 'none',
    stroke: '#FF0000',
    strokeWidth: '9',
    strokeMiterlimit: '10',
    d: 'M19.4,58.9'
  }), _react2.default.createElement('g', null, _react2.default.createElement('g', null, _react2.default.createElement('path', {
    fill: '#30CADA',
    d: 'M36.4,72.3h9V49.9c-2.6,2-5.7,3.7-9,4.4V72.3z'
  })), _react2.default.createElement('polygon', {
    fill: '#30CADA',
    points: '54.4,0.3 54.4,72.3 63.4,72.3 63.4,18.3 72.4,18.3 \t\t'
  }), _react2.default.createElement('rect', {
    x: '18.4',
    y: '54.3',
    fill: '#30CADA',
    width: '9',
    height: '18'
  })), _react2.default.createElement('rect', {
    x: '0.4',
    y: '54.3',
    fill: '#30CADA',
    width: '9',
    height: '18'
  })));
};